






import { PageTemplate } from './page_template'

export function Page1() {
    return <PageTemplate>
        
        <div className="page-section">
            <h2> SEQUENCE AND AUTOMATE </h2>
            {/* <div className="row"> */}
                <span className="text _2">
                    Draw your own automation curves, construct sequences,
                    apply LFOs, and arrange notes. Create as many
                    polyphonic sequencers as you want.
                </span>
                <div className="pic _0 shadow"></div>
            {/* </div> */}
        </div>

        <div className="page-section">
            <h2 className="center"> CONTROL THE SOURCE </h2>
            <div className="row center">
                <div className="pic _1"></div>
                <span className="text _2">
                    Use the code editor built into processor node to
                    unleash unlimited potential. NUNISYNTH comes with
                    user-friendly examples that can be modified.
                </span>
            </div>
        </div>
        
        <div className="page-section">
            <h2 className="center"> CONSTRUCT MODULES </h2>
            <div className="row center">
                <span className="text _4">
                    Construct your own unique nodes with Modules.
                    NUNISYNTH includes examples that can be studied and forked.
                </span>
                <div className="pic _2 shadow"></div>
            </div>
        </div>
    </PageTemplate>
}